import { Bubble, mixins } from 'vue-chartjs';

export default {
  name: 'bubble-chart',
  mixins: [mixins.reactiveProp],
  extends: Bubble,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      delayed: true,
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
};
